import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import ArrowUp from '@material-ui/icons/KeyboardArrowUp';
import { IList, IListProps } from 'components/List/List';
import withColorQuery, { WithColorQueryProps } from 'enhancers/withColorQuery';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  items: IList[];
}

type Props = IProps &
  IListProps &
  WithColorQueryProps &
  IWithCountryProps &
  WithLanguageProps;

export const ListNav: React.SFC<Props> = props => {
  const isFirst = props.index === 0;
  const isLast = props.index === props.items.length - 1;
  const onNext = () => {
    const nextIndex = props.index + 1;
    if (props.items[nextIndex]) {
      props.changeItem(nextIndex);
    }
  };
  const onPrev = () => {
    const nextIndex = props.index - 1;
    if (props.items[nextIndex]) {
      props.changeItem(nextIndex);
    }
  };
  return (
    <Container>
      <div>
        <NavItem onClick={onPrev} disable={isFirst}>
          <ArrowUp />
          <div>Prev</div>
        </NavItem>
      </div>
      <div>
        <NavItem onClick={onNext} disable={isLast}>
          <div>Next</div>
          <ArrowDown />
        </NavItem>
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 20px;
  @media (max-width: 900px) {
    display: none;
  }
`;

const NavItem = styled.div<{ disable: boolean }>`
  opacity: ${p => (p.disable ? '0.5' : 'initial')};
  cursor: ${p => (p.disable ? 'not-allowed' : 'pointer')};
  user-select: ${p => (p.disable ? 'none' : 'initial')};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default withLanguageState(withCountry(withColorQuery(ListNav)));



// WEBPACK FOOTER //
// ./src/components/ListNav/ListNav.tsx